/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';

import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

import * as overrides from '../../operation-overrides/getFlagArchiveChecksOverrides';
import type { GetFlagArchiveChecksQueryParams } from '../../operation-overrides/getFlagArchiveChecksOverrides';

export type GetFlagArchiveChecksPathParams = NonNullable<operations['getFlagArchiveChecks']['parameters']['path']>;
export type { GetFlagArchiveChecksQueryParams };

export interface Input extends GetFlagArchiveChecksPathParams {
  apiVersion?: string;
  query?: GetFlagArchiveChecksQueryParams;
  header: NonNullable<operations['getFlagArchiveChecks']['parameters']['header']>;
}

export async function getFlagArchiveChecks(
  { apiVersion, query, header, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().GET('/internal/projects/{projKey}/flag-archive-checks/{flagKey}', {
    params: {
      path,
      // @ts-ignore We explicitly ignore errors here because we know the types may not match the spec
      query,
      header,
    },
    // @ts-ignore We explicitly ignore errors here because we know the types may not match the spec
    querySerializer: overrides.querySerializer,
    headers: apiVersion ? mergeHeaders(headers, { 'LD-API-Version': apiVersion }) : headers,
    signal,
  });
}
